import React, { useContext, useState, useEffect } from "react";
import "../../../assests/css/admin/ExamManagement.css";
import {
  Calendar,
  BookOpen,
  FileText,
  CheckCircle,
  Plus,
  Edit2,
  Trash2,
  Download,
} from "lucide-react";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";

const ExamManagement = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [adminExams, setAdminExams] = useState([]);
  const [teacherExams, setTeacherExams] = useState([]);
  const [activeTab, setActiveTab] = useState("schedule");
  // const [exam, setExam] = useState([]);
  const [results, setResults] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("exam");
  const [selectedItem, setSelectedItem] = useState(null);
  // const [courses, setCourses] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [Programmes, setProgrammes] = useState([]);
  // const [course, setCourse] = useState("");
  const [department, setDepartment] = useState("");
  const [fileName, setFileName] = useState(null);
  const [Programme, setProgramme] = useState("");
  const [semester, setSemester] = useState("");
  const [uploads, setUploads] = useState([]);
  const [addActionLoading, setAddActionLoading] = useState(false);

  const [examIdForUpdate, setExamIdForUpdate] = useState(null);

  // ── Download states ──
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadExam, setDownloadExam] = useState(null);

  useEffect(() => {
    viewAllExams();
    viewAllTeacherExams();
    viewAllDepartments();
  }, []);

  const handleOpenModal = (type, item = null) => {
    // setExamIdForUpdate(item.id);
    setModalType(type);
    setSelectedItem(item);
    if (item) {
      // setCourse(item.course || "");
      // setCourse(item.ngcourse_id || "");
      setSemester(item.semester || item.class || "");
      setFileName(item.fileName || "");
      // setDate(item.date || "");
      // setTime(item.time || "");
      // setDuration(item.duration || "");
      // setMarks(item.totalMarks || item.marks || "");
    } else {
      resetForm();
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
    resetForm();
  };

  const resetForm = () => {
    setDepartment("");
    setProgramme("");
    // setCourse("");
    setSemester("");
    setFileName("");
    setExamIdForUpdate(null);
  };

  const viewAllExams = () => {
    axios
      .get(`${baseUrl}/admin/exam/viewAllExams`)
      .then((response) => {
        setAdminExams(response.data.exam);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const viewAllTeacherExams = () => {
    axios
      .get(`${baseUrl}/admin/exam/viewAllTeacherExams`)
      .then((response) => {
        console.log("Teacher Exams:", response.data);
        setTeacherExams(response.data.exam);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const viewAllDepartments = () => {
    axios
      .get(`${baseUrl}/admin/department/viewAllDepartments`)
      .then((response) => {
        console.log(response.data);
        setDepartments(response.data.departments);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const isJpgFile = (file) => {
    if (!file || !file.name) return false;
    const fileExt = file.name.split(".").pop().toLowerCase();
    return (
      ["image/jpeg", "image/jpg"].includes(file.type) &&
      ["jpg", "jpeg"].includes(fileExt)
    );
  };

  const addExam = () => {
    // Semester validation
    const semesterValues = semester
      .split(",")
      .map((value) => value.trim())
      .filter((value) => value !== "");

    const validSemester =
      semesterValues.length > 0 &&
      semesterValues.every((value) =>
        ["1", "2", "3", "4", "5", "6", "7", "8"].includes(value),
      );

    if (!validSemester) {
      setAddActionLoading(false);

      Swal.fire({
        icon: "error",
        title: "Invalid Semester",
        text: "Sirf semester 1 se 8 tak allowed hain. Example: 1,2,3,4",
      });

      return;
    }
    if (!fileName || !isJpgFile(fileName)) {
      setAddActionLoading(false);
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text: "Sirf JPG file upload kar sakte hain (.jpg ya .jpeg).",
      });
      return;
    }

    const formData = new FormData();
    formData.append("ngdepartment_id", department);
    formData.append("ngprogramme_id", Programme);
    // formData.append("ngcourse_id", course);
    formData.append("semester", semester);
    if (fileName) formData.append("fileName", fileName);

    axios
      .post(`${baseUrl}/admin/exam/addExam`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        setAddActionLoading(false);
        if (response.data.success === true) {
          setUploads((prev) => [
            {
              // ngdepartment: {
              //   name: departments.find((d) => d.id == department)?.name,
              // },
              fileName: fileName.name,
            },
            ...prev,
          ]);
          // setDepartment("");
          // setProgramme("");
          // setCourse("");
          // setSemester("");
          // setDate("");
          // setTime("");
          // setDuration("");
          // setMarks("");
          viewAllExams();
          resetForm();
          setShowModal(false);
          Swal.fire({
            icon: "success",
            title: "Exam schedule uploaded successfully!",
            confirmButtonText: "Okay",
          });
        }
      })
      // .catch((error) => {
      //   console.log(error);
      // });
      .catch((error) => {
        console.log("FULL ERROR:", error);
        console.log("RESPONSE:", error.response);
        console.log("DATA:", error.response?.data);
        setAddActionLoading(false);

        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: error.response?.data?.message || "Something went wrong",
        });
      });
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
  };
  // const updateExam = () => {
  //   console.log("Updated ka function chl rha ha dehan sy dekho");
  //   const formData = new FormData();
  //   formData.append("exam_id", examIdForUpdate);
  //   formData.append("department", department);
  //   formData.append("programme", Programme);
  //   formData.append("course", course);
  //   formData.append("semester", semester);
  //   formData.append("date", date);
  //   formData.append("time", time);
  //   formData.append("duration", duration);
  //   formData.append("marks", marks);

  //   axios
  //     .post(`${baseUrl}/admin/exam/updateExam`, formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       viewAllExams();
  //       resetForm();
  //       setShowModal(false);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  const handleSubmit = () => {
    setAddActionLoading(true);
    if (examIdForUpdate === null) {
      addExam();
    }
    // } else {
    //   updateExam();
    // }
  };
  // const deleteExam = (idToDelete) => {
  //   console.log("*************");
  //   console.log(idToDelete);
  //   console.log("*************");
  //   const formData = new FormData();
  //   formData.append("exam_id", idToDelete);

  //   axios
  //     .post(`${baseUrl}/admin/exam/deleteExam`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/formdata",
  //       },
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       viewAllExams();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const handleSaveExam = () => {
  //   selectedItem ? updateExam() : addExam();
  // };

  // ── Subject card click → open download modal (file already exists, just preview/download) ──
  const handleSubjectCardClick = (examItem) => {
    setDownloadExam(examItem);
    setShowDownloadModal(true);
  };

  const handleCloseDownloadModal = () => {
    setShowDownloadModal(false);
    setDownloadExam(null);
  };

  // ── Download logic: file already uploaded (by teacher or admin) — just fetch it ──
  const handleDownloadPaper = () => {
    if (!downloadExam?.fileName) {
      alert("Is exam ke liye koi file upload nahi hui.");
      return;
    }

    const ext = downloadExam.fileName.split(".").pop().toLowerCase();
    if (!["jpg", "jpeg"].includes(ext)) {
      alert(
        "Ye file JPG format mein nahi hai, isliye download allowed nahi hai.",
      );
      return;
    }

    const link = document.createElement("a");
    link.href = `${baseUrlForFiles}/${downloadExam.fileName}`;
    link.target = "_blank";
    link.rel = "noreferrer";
    link.download = downloadExam.fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    handleCloseDownloadModal();
  };

  // ── Group exams by Course + Semester (unique cards, dynamic from DB) ──
  const uniqueSubjects = teacherExams.filter(
    (examItem, index, self) =>
      index ===
      self.findIndex(
        (e) =>
          e.ngcourse_id === examItem.ngcourse_id &&
          e.semester === examItem.semester,
      ),
  );

  // const viewAllProgramme = () => {
  //   axios
  //     .get(`${baseUrl}/admin/programme/viewAllProgramme`)
  //     .then((response) => {
  //       console.log(response.data);
  //       setProgrammes(response.data.programmes);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const viewAllCourses = () => {
  //   axios
  //     .get(`${baseUrl}/Admin/Courses/viewAllCourses`)
  //     .then((response) => {
  //       console.log(response.data);
  //       setCourses(response.data.courses);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  return (
    <Adminmasterlayout>
      <div className="em">
        <div className="em__container">
          {/* ── HEADER ── */}
          <div className="em__header">
            <div className="em__header-content">
              <h1 className="em__header-title">Exam Management</h1>
              <p className="em__header-subtitle">
                Manage exam, results, and publications
              </p>
            </div>
          </div>

          {/* ── TABS ── */}
          <div className="em__tabs">
            <button
              className={`em__tab ${activeTab === "schedule" ? "em__tab--active" : ""}`}
              onClick={() => setActiveTab("schedule")}
            >
              <Calendar size={18} />
              Exam Schedule
            </button>
            <button
              className={`em__tab ${activeTab === "download" ? "em__tab--active" : ""}`}
              onClick={() => setActiveTab("download")}
            >
              <Download size={18} />
              Download Exam Paper
            </button>
          </div>

          <div className="em__content">
            {/* ── EXAM SCHEDULE TAB ── */}
            {activeTab === "schedule" && (
              <div className="em__schedule">
                <div className="em__schedule-header">
                  <h2 className="em__schedule-heading">Scheduled Exams</h2>
                  <button
                    className="em__btn-add"
                    onClick={() => handleOpenModal("exam")}
                  >
                    <Plus size={20} />
                    Add Exam
                  </button>
                </div>
                <div className="em__table-wrapper">
                  <table className="em__table">
                    <thead className="em__table-head">
                      <tr className="em__table-row">
                        <th className="em__table-header">Department</th>
                        <th className="em__table-header">Programme</th>
                        {/* <th className="em__table-header">Course</th> */}
                        <th className="em__table-header">Semester</th>
                        <th className="em__table-header">Date sheet image</th>

                        {/* <th className="em__table-header">Date</th>
                        <th className="em__table-header">Time</th>
                        <th className="em__table-header">Duration</th>
                        <th className="em__table-header">Total Marks</th>
                        <th className="em__table-header">Actions</th> */}
                      </tr>
                    </thead>
                    <tbody className="em__table-body">
                      {adminExams.length > 0 ? (
                        adminExams.map((examItem) => (
                          <tr key={examItem.id} className="em__table-row">
                            <td className="em__table-cell">
                              {examItem.ngdepartment?.deptName}
                            </td>
                            <td className="em__table-cell">
                              {examItem.ngprogramme?.progName}
                            </td>

                      
                            <td className="em__table-cell">
                              <span className="em__table-badge">
                                {examItem.semester}
                              </span>
                            </td>
                            <td>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={`${baseUrlForFiles}/${examItem.fileName}`}
                              >
                                {examItem.fileName}
                              </a>
                            </td>
                            {/* <td className="em__table-cell">{exam.date}</td>
                            <td className="em__table-cell">{exam.time}</td>
                            <td className="em__table-cell">{exam.duration}</td> */}
                            {/* <td className="em__table-cell">
                              <span className="em__table-marks">
                                {exam.marks}
                              </span>
                            </td> */}
                            {/* <td className="em__table-cell">
                              <div className="em__table-actions">
                                <button
                                  className="em__table-btn em__table-btn--edit"
                                  onClick={() => handleOpenModal("exam", exam)}
                                  title="Edit"
                                >
                                  <Edit2 size={16} />
                                </button>
                                <button
                                  className="em__table-btn em__table-btn--delete"
                                  onClick={() => deleteExam(exam.id)}
                                  title="Delete"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="em__table-empty">
                            No exam scheduled yet.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* ── DOWNLOAD EXAM PAPER TAB ── */}
            {activeTab === "download" && (
              <div className="em__schedule">
                <div className="em__schedule-header">
                  <h2 className="em__schedule-heading">Download Exam Paper</h2>
                </div>

                {uniqueSubjects.length > 0 ? (
                  <div className="em__course-grid">
                    {uniqueSubjects.map((examItem) => (
                      <button
                        key={examItem.id}
                        className="em__course-card"
                        onClick={() => handleSubjectCardClick(examItem)}
                      >
                        <BookOpen size={20} className="em__course-card-icon" />
                        <span className="em__course-card-name">
                          {examItem.ngcourse?.name || "—"}
                        </span>
                        <span className="em__course-card-semester">
                          Semester {examItem.semester || "N/A"}
                        </span>
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="em__publish-empty">
                    <FileText size={48} className="em__publish-empty-icon" />
                    <p className="em__publish-empty-text">
                      No courses available.
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ── ADD / EDIT EXAM MODAL ── */}
          {showModal && (
            <div className="em-modal__overlay" onClick={handleCloseModal}>
              <div className="em-modal" onClick={(e) => e.stopPropagation()}>
                <div className="em-modal__header">
                  <h2 className="em-modal__title">
                    {modalType === "exam" &&
                      (selectedItem ? "Edit Exam" : "Add New Exam")}
                  </h2>
                  <button
                    className="em-modal__close"
                    onClick={handleCloseModal}
                  >
                    ×
                  </button>
                </div>
                <div className="em-modal__body">
                  <div className="em-modal__form">
                    <div className="csm__form-group">
                      <label className="csm__form-label">Department</label>
                      <select
                        type="text"
                        className="csm__form-input"
                        placeholder="Enter department"
                        value={department}
                        onChange={(e) => {
                          let selecteddepartmentfromdropdown = departments.find(
                            (dept) => dept.id == e.target.value,
                          );
                          setProgrammes(
                            selecteddepartmentfromdropdown?.ngprogramme || [],
                          );
                          setDepartment(e.target.value);
                        }}
                      >
                        <option value="0">SELECT DEPARTMENT</option>
                        {departments.map((dept) => {
                          return (
                            <option key={dept.id} value={dept.id}>
                              {dept.deptName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="csm__form-group">
                      <label className="csm__form-label">Programme</label>
                      <select
                        type="text"
                        className="csm__form-input"
                        placeholder="Enter programme"
                        value={Programme}
                        onChange={(e) => {
                          let selectedprogramfromdropdown = Programmes.find(
                            (prog) => prog.id == e.target.value,
                          );
                          // setCourses(
                          //   selectedprogramfromdropdown?.ngcourses || [],
                          // );
                          setProgramme(e.target.value);
                        }}
                      >
                        <option value="0">SELECT PROGRAMME</option>
                        {Programmes.map((prog) => {
                          return (
                            <option key={prog.id} value={prog.id}>
                              {prog.progName}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="em-modal__form-group">
                      {/* <label className="em-modal__form-label">
                        Semester number separate with comma.(i:e 2,3,4,5)
                      </label> */}
                      <label className="em-modal__form-label">
                        Semester (1–8, comma separated)
                      </label>
                      <input
                        value={semester}
                        type="text"
                        className="form-control"
                        placeholder="Example: 1,2,3,4"
                        onChange={(e) => {
                          const value = e.target.value;

                          // Sirf numbers aur comma allow
                          if (!/^[0-9,]*$/.test(value)) {
                            return;
                          }

                          setSemester(value);
                        }}
                      />
                      {/* <input
                        value={semester}
                        onChange={(e) => {
                          setSemester(e.target.value);
                        }}
                        type="text"
                        className="form-control"
                      /> */}
                    </div>

                    <div className="em-modal__form-group">
                      <label className="em-modal__form-label">
                        Date sheet image (JPG only).
                      </label>
                      <input
                        type="file"
                        accept=".jpg,.jpeg,image/jpeg"
                        className="form-control"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) {
                            setFileName(null);
                            return;
                          }
                          if (!isJpgFile(file)) {
                            Swal.fire({
                              icon: "error",
                              title: "Invalid File",
                              text: "Sirf JPG file upload kar sakte hain (.jpg ya .jpeg).",
                            });

                            e.target.value = "";
                            setFileName(null);
                            return;
                          }
                          setFileName(file);
                        }}
                      />
                      <small
                        style={{
                          color: "#888",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        Sirf .jpg / .jpeg file allowed hai.
                      </small>
                      {/* <input
                        onChange={(e) => {
                          setFileName(e.target.files[0]);
                        }}
                        type="file"
                        className="form-control"
                      /> */}
                    </div>
                  </div>
                </div>
                <div className="em-modal__footer">
                  <button
                    className="em-modal__btn em-modal__btn--cancel"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button>
                  {addActionLoading ? (
                    <Spinner size="lg" />
                  ) : (
                    <button
                      className="em-modal__btn em-modal__btn--save"
                      onClick={handleSubmit}
                    >
                      {selectedItem ? "Update" : "Save"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ── DOWNLOAD PAPER MODAL (opens on course+semester card click) ── */}
          {showDownloadModal && downloadExam && (
            <div
              className="em-modal__overlay"
              onClick={handleCloseDownloadModal}
            >
              <div className="em-modal" onClick={(e) => e.stopPropagation()}>
                <div className="em-modal__header">
                  <h2 className="em-modal__title">
                    Download — {downloadExam.ngcourse?.name}
                  </h2>
                  <button
                    className="em-modal__close"
                    onClick={handleCloseDownloadModal}
                  >
                    ×
                  </button>
                </div>
                <div className="em-modal__body">
                  <div className="em-modal__form">
                    <p
                      className="em-modal__form-label"
                      style={{ fontWeight: 400, color: "#745f59" }}
                    >
                      <strong>Teacher:</strong>{" "}
                      {downloadExam.ngteacher?.fullname || "—"} &nbsp;|&nbsp;
                      <strong>Course:</strong>{" "}
                      {downloadExam.ngcourse?.name || "—"} &nbsp;|&nbsp;
                      <strong>Semester:</strong>{" "}
                      {downloadExam.semester || "N/A"}
                    </p>

                    {/* File already uploaded by teacher/admin — just show ready state */}
                    {downloadExam.fileName &&
                    ["jpg", "jpeg"].includes(
                      downloadExam.fileName.split(".").pop().toLowerCase(),
                    ) ? (
                      <div className="em-modal__info-box em-modal__info-box--success">
                        <CheckCircle size={18} />
                        <span>Exam paper ready: {downloadExam.fileName}</span>
                      </div>
                    ) : downloadExam.fileName ? (
                      <div className="em-modal__info-box em-modal__info-box--warning">
                        Ye file JPG format mein nahi hai (
                        {downloadExam.fileName}). Sirf JPG files download ki ja
                        sakti hain.
                      </div>
                    ) : (
                      <div className="em-modal__info-box em-modal__info-box--error">
                        Is exam ke liye koi file upload nahi hui.
                      </div>
                    )}
                  </div>
                </div>
                <div className="em-modal__footer">
                  
                  <button
                    className="em-modal__btn em-modal__btn--cancel"
                    onClick={handleCloseDownloadModal}
                  >
                    Cancel
                  </button>
                  {/* <button
                    className="em-modal__btn em-modal__btn--save"
                    onClick={handleDownloadPaper}
                    disabled={
                      !downloadExam.fileName ||
                      !["jpg", "jpeg"].includes(
                        downloadExam.fileName.split(".").pop().toLowerCase()
                      )
                    }
                  >
                    <Download size={16} style={{ marginRight: "6px" }} />
                    Download
                  </button> */}
                  <button
                    className="em-modal__btn em-modal__btn--save"
                    onClick={() =>
                      window.open(
                        `${baseUrlForFiles}/${downloadExam.fileName}`,
                        "_blank",
                      )
                    }
                  >
                    View Paper
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Adminmasterlayout>
  );
};

export default ExamManagement;
